exports.components = {
  "component---src-components-templates-page-tsx": () => import("./../../../src/components/templates/Page.tsx" /* webpackChunkName: "component---src-components-templates-page-tsx" */)
}

